import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
const st0 = { fill: "#FFF" };
function WorkWaveLogoContrast(props) {
  const { width = "100%", sx = {}, ...rest } = props;
  return /* @__PURE__ */ jsx(
    SvgIcon,
    {
      "data-testid": "workWaveLogo",
      titleAccess: "WorkWave Logo",
      viewBox: "0 0 787.6 176.4",
      sx: { ...sx, height: "auto", width },
      ...rest,
      children: /* @__PURE__ */ jsxs("g", { id: "ww-logo_1_", children: [
        /* @__PURE__ */ jsxs("g", { id: "workwave_2_", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              style: st0,
              d: "M787.6 59.6c0 3.8-2.9 6.7-6.7 6.7-3.7 0-6.7-3-6.7-6.7s3-6.6 6.7-6.6c3.8 0 6.7 2.9 6.7 6.6zm-12.2 0c0 3.3 2.4 5.9 5.6 5.9 3.2 0 5.5-2.6 5.5-5.9 0-3.3-2.3-5.9-5.6-5.9-3.1 0-5.5 2.6-5.5 5.9zm4.5 3.5h-1.5v-6.6c.6-.1 1.4-.2 2.5-.2 1.2 0 1.8.2 2.3.5.4.3.6.8.6 1.5s-.6 1.3-1.3 1.5v.1c.6.2 1 .7 1.2 1.6.2 1 .3 1.4.5 1.7h-1.6c-.2-.2-.3-.8-.5-1.6-.1-.7-.5-1.1-1.3-1.1h-.7v2.6zm.1-3.8h.7c.8 0 1.5-.3 1.5-1 0-.6-.4-1-1.4-1-.4 0-.7 0-.8.1v1.9z"
            }
          ),
          /* @__PURE__ */ jsx("g", { id: "XMLID_49_", children: /* @__PURE__ */ jsxs("g", { id: "XMLID_50_", children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_64_",
                style: st0,
                d: "M267.1 55.5c-2.7 0-5 1.8-5.8 4.2l-11.8 36.9-10.6-36.9c-.7-2.5-3.1-4.2-5.6-4.2-2.6 0-4.8 1.8-5.5 4.2l-10.5 36.8-11.9-36.8c-.8-2.5-3.2-4.2-5.8-4.2-3.3 0-6.1 2.8-6.1 6.1 0 2.8 16 50.9 18 56.9.8 2.5 3.1 4.2 5.8 4.2 2.7 0 5.1-1.7 5.8-4.2l10.3-36 10.3 36c.7 2.6 3.1 4.2 5.7 4.2 2.7 0 5-1.8 5.8-4.2 2-6 18-54.1 18-56.9 0-3.4-2.8-6.1-6.1-6.1"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_63_",
                style: st0,
                d: "M468.5 81.2 484 65.9c1.2-1.2 1.9-2.7 1.9-4.3 0-3.3-2.8-6.1-6.1-6.1-1.6 0-3.1.7-4.2 1.8l-28.5 28V62.1c0-3.5-2.9-6.6-6.5-6.6s-6.6 3-6.6 6.6v54c0 3.6 3 6.6 6.6 6.6 3.6 0 6.5-3.1 6.5-6.6v-13.9c4.1-4.1 8.4-8.2 12.5-12.3l18.5 29.8c1.1 1.8 3.2 3 5.2 3 3.3 0 6-2.8 6-6.1 0-1.1-.3-2.2-.9-3.2l-19.9-32.2z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_62_",
                style: st0,
                d: "M575.3 55.5c-2.7 0-5 1.8-5.8 4.2l-11.8 36.9-10.6-36.9c-.7-2.5-3.1-4.2-5.6-4.2-2.6 0-4.8 1.8-5.5 4.2l-10.5 36.8-11.9-36.8c-.8-2.5-3.2-4.2-5.8-4.2-3.4 0-6.1 2.8-6.1 6.1 0 2.8 16 50.9 18 56.9.8 2.5 3.1 4.2 5.8 4.2 2.7 0 5.1-1.7 5.8-4.2l10.3-36 10.3 36c.7 2.6 3.1 4.2 5.7 4.2 2.7 0 5-1.8 5.8-4.2 2-6 18-54.1 18-56.9 0-3.4-2.7-6.1-6.1-6.1"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_61_",
                style: st0,
                d: "M700 55.5c-2.4 0-4.5 1.4-5.5 3.5L676 103l-18.3-44c-.9-2.3-3.2-3.5-5.6-3.5-3.2 0-6 3-6 6.2 0 .8.2 1.7.5 2.5l23.9 55c1 2.3 3.1 3.5 5.6 3.5 2.4 0 4.6-1.4 5.5-3.5l23.8-55c.4-.8.6-1.7.6-2.6.1-3.4-2.7-6.1-6-6.1"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_60_",
                style: st0,
                d: "M764.8 109.6h-30.7V95h16.2c3.3 0 6.1-2.7 6.1-6.1 0-3.4-2.8-6.2-6.1-6.2h-16.2v-14h29.2c3.4 0 6.2-2.8 6.2-6.2 0-3.3-2.9-6.1-6.2-6.1h-35.7c-3.6 0-6.6 2.9-6.6 6.5v52.5c0 3.6 3 6.6 6.6 6.6h37.2c3.3 0 6.2-2.7 6.2-6.1 0-3.4-2.8-6.3-6.2-6.3"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_57_",
                style: st0,
                d: "M315.5 55.2c-18.9 0-33.7 15.1-33.7 34s14.8 34.1 33.7 34.1c18.9 0 33.6-15.2 33.6-34.1 0-19-14.7-34-33.6-34m0 55.9c-12.3 0-20.6-9.8-20.6-22 0-12.1 8.3-21.8 20.6-21.8S336 77 336 89.1c0 12.1-8.2 22-20.5 22"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_54_",
                style: st0,
                d: "M418.2 76.1c0-14.4-10.9-19.7-23.9-19.7h-24.4c-3.6 0-6.5 2.9-6.5 6.5v53.3c0 3.6 2.9 6.5 6.5 6.5 3.5 0 6.6-2.9 6.6-6.5V95.4h18c.1.5 10.7 21.8 11.7 23.7 1.1 2.2 3.2 3.5 5.6 3.5 3.5 0 6.4-2.9 6.4-6.3 0-3.1-8.9-19.5-10.7-23.2 7.2-3 10.7-9.4 10.7-17m-22 8.1h-19.7V68.5h19.7c4.9 0 9 2.8 9 8-.1 5.2-4.2 7.7-9 7.7"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_51_",
                style: st0,
                d: "M584 114c-.3.8-.5 1.7-.5 2.6 0 3.3 2.7 6.1 6 6.1 1.4 0 2.7-.5 3.7-1.5.7-.5 1.3-1.2 1.6-2 .4-.8 8.5-17 30.7-19.4l8.7 19.3c1 2.2 3.1 3.5 5.5 3.5 3.4 0 6.2-2.9 6.2-6.2 0-.8-.2-1.7-.6-2.5l-25.2-55c-.9-2.1-3.1-3.5-5.4-3.5-2.4 0-4.6 1.3-5.7 3.5L584 114zm37-24.5c-5.8 1-10.7 2.7-14.9 4.8l8.7-18.8 6.2 14z"
              }
            )
          ] }) })
        ] }),
        /* @__PURE__ */ jsxs("g", { id: "_Group_5_28_", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              style: st0,
              d: "m92.7 77.2.4-1-.4 1zM87.9 0C39.3.1-.1 39.6 0 88.2s39.6 88 88.2 87.9c48.6-.1 88-39.6 87.9-88.2 0-48.6-39.5-88-88.2-87.9zM9.1 80.1c.7-3.4 4-5.6 7.4-4.9 3.4.7 5.6 4 4.9 7.4-.7 3.4-4 5.6-7.4 4.9-3.4-.7-5.6-4-4.9-7.4zm4.6 20.9-.6-2.2c-.1-.4-.2-.7-.3-1.1-.8-4 1.7-7.9 5.7-8.7 4-.8 7.9 1.7 8.7 5.7l.6 2.2c.1.4.2.7.3 1.1.8 4-1.7 7.9-5.7 8.7-3.9.8-7.8-1.8-8.7-5.7zm24 16.1-2 4.4c-1.7 3.7-6.1 5.3-9.8 3.5-3.6-1.7-5.2-5.9-3.7-9.5l2.3-5.1c1.6-3.7 6-5.4 9.7-3.7 3.8 1.6 5.2 6.7 3.5 10.4zm82.1 20.4s-2.1 4.8-7.4 4.5c-2.9 0-5.5-1.8-6.6-4.5L88.9 86.3l-17.6 42.1c-.9 2-2.6 3.5-4.7 4.2-4 1.2-8.3-1-9.6-5.1L46.6 96l-1.7 4.1c-.3.7-.7 1.3-1.2 1.9-2.1 2.5-5.6 3.2-8.6 1.9-3.7-1.6-5.4-6-3.7-9.7l.3-.7 8.6-22.8c1.7-3.9 6.2-5.6 10.1-3.9 1.8.8 3.2 2.3 4 4.1l.1.3 3.9 11.4.7 2.1s0 .1.1.1l.1.2 6 17.4 17.4-41.6c1.7-3.9 6.2-5.6 10.1-3.9 2.1 1 3.7 2.9 4.3 5.2l4 12.4.3 1.1s0 .1.1.1l-.2-.6.1.2c.5 1.2 12.1 36.8 12.1 36.8l27.4-64.9s3.8-6.6 10-3.6c6.2 3 4.2 9.3 4.2 9.3l-35.3 84.6z"
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "_Path_9_1_",
              gradientUnits: "userSpaceOnUse",
              x1: 50.855,
              y1: -1027.722,
              x2: 41.567,
              y2: -1022.573,
              gradientTransform: "matrix(1 0 0 -1 0 -925.077)",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0, stopColor: "#4d4a4a", stopOpacity: 0 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#221f1f" })
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "_Path_9_40_",
              d: "m65.3 102.4-6-17.4-.1-.2c-.7-1.8-2.5-3.6-4.9-2.9-2 .6-3 2.5-3.5 3.6l-4.2 10.4L57 127.4c1.2 4 5.5 6.3 9.6 5.1 2.1-.6 3.8-2.2 4.7-4.2l1.6-3.8-7.6-22.1z",
              opacity: 0.7,
              fill: "url(#_Path_9_1_)"
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "_Path_10_1_",
              gradientUnits: "userSpaceOnUse",
              x1: 90.291,
              y1: -1024.397,
              x2: 75.036,
              y2: -1015.935,
              gradientTransform: "matrix(1 0 0 -1 0 -925.077)",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0, stopColor: "#221f1f", stopOpacity: 0 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.02, stopColor: "#221f1f", stopOpacity: 0.04 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.19, stopColor: "#221f1f", stopOpacity: 0.31 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.36, stopColor: "#221f1f", stopOpacity: 0.53 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.53, stopColor: "#221f1f", stopOpacity: 0.71 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.69, stopColor: "#221f1f", stopOpacity: 0.83 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.85, stopColor: "#221f1f", stopOpacity: 0.9 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#221f1f", stopOpacity: 0.93 })
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "_Path_10_40_",
              d: "m113.5 112-2-6.2-9.9-30.1c-.6-1.9-2.4-3.8-4.9-3.1-2 .6-3 2.5-3.5 3.6l-4.2 10v.1l16.9 51.2c1.1 2.7 3.7 4.5 6.6 4.5 5.2.3 7.4-4.5 7.4-4.5l1.2-2.8-7.6-22.7z",
              opacity: 0.7,
              fill: "url(#_Path_10_1_)"
            }
          )
        ] })
      ] })
    }
  );
}
export {
  WorkWaveLogoContrast
};
//# sourceMappingURL=WorkWaveLogoContrast.js.map
